// SteamID64 складається рівно з 17 цифр
export const STEAM_ID_LENGTH = 17;

export const validateSteamId = (steamId: string): boolean => /^\d{17}$/.test(steamId.trim());
